/**
 * Application Constants
 * Shared constants and configuration values
 */

export interface CompanyInfo {
  name: string;
  shortName: string;
  tagline: string;
  location: string;
  logo: string;
}

export interface NavigationLink {
  label: string;
  href: string;
}

export interface StrategyPillar {
  title: string;
  description: string;
}

export interface FocusArea {
  id: string;
  title: string;
  description: string;
}

export interface ProcessStep {
  number: string;
  title: string;
  description: string;
}

export interface PortfolioCompany {
  name: string;
  industry: string;
  description: string;
  status: string;
}

export interface LeadershipMember {
  name: string;
  role: string;
  bio: string;
}

export const COMPANY_INFO: CompanyInfo = {
  name: 'Arceus Wealth',
  shortName: 'Arceus',
  tagline: 'Strategic Investments in Exceptional Individuals',
  location: 'Vancouver, BC',
  logo: '/arceus-logo.png',
};

export const NAVIGATION_LINKS: NavigationLink[] = [
  { label: 'Strategy', href: '/#strategy' },
  { label: 'Focus Areas', href: '/#focus-areas' },
  { label: 'Approach', href: '/#approach' },
  { label: 'Leadership', href: '/#leadership' },
  { label: 'Contact', href: '/contact.html' },
];

export const STRATEGY_PILLARS: StrategyPillar[] = [
  {
    title: 'Disciplined Capital Allocation',
    description: 'We execute a rigorous, thesis-driven investment process to identify and partner with individuals with durable potential and long-term earnings capability.',
  },
  {
    title: 'Operational Value Creation',
    description: 'We work directly with our partners to drive improvement, growth, and structural efficiency.',
  },
  {
    title: 'Scalable Growth Strategy',
    description: 'We provide the capital, network, and strategic expertise required to scale operations, expand into adjacent markets, and execute targeted growth initiatives.',
  },
];

export const FOCUS_AREAS: FocusArea[] = [
  {
    id: 'healthcare',
    title: 'Healthcare',
    description: 'Acquiring and growing medical technology, services, and specialty health platforms that improve patient outcomes and generate durable, recurring enterprise revenue.',
  },
  {
    id: 'technology',
    title: 'Technology',
    description: 'Partnering with software and tech-enabled service companies that command mission-critical enterprise relationships and scalable, high-margin business models.',
  },
];

export const PROCESS_STEPS: ProcessStep[] = [
  {
    number: '01',
    title: 'Source',
    description: 'We identify high potential business, real estate, and equities through our network, sector research, and proactive outreach',
  },
  {
    number: '02',
    title: 'Acquire',
    description: 'We structure disciplined, thesis-aligned investments through rigorous due diligence — evaluating partner quality, financial performance, and growth vectors.',
  },
  {
    number: '03',
    title: 'Grow',
    description: 'Our operating partners work alongside management to accelerate revenue growth, improve operational efficiency, expand into new markets, and execute strategic add-on acquisitions.',
  },
];

export const PORTFOLIO_COMPANIES: PortfolioCompany[] = [];

export const LEADERSHIP: LeadershipMember[] = [
  {
    name: 'Andrew Y.',
    role: 'Founder & Owner',
    bio: 'Andrew founded Arceus Wealth Management and serves as its sole principal. He brings extensive experience in wealth management, strategic M&A, and operational transformation across North America and Asia-Pacific — guiding every investment from origination through long-term growth with disciplined conviction.',
  },
];

export default {
  COMPANY_INFO,
  NAVIGATION_LINKS,
  STRATEGY_PILLARS,
  FOCUS_AREAS,
  PROCESS_STEPS,
  PORTFOLIO_COMPANIES,
  LEADERSHIP,
};
